import { Button, CircularProgress, Typography } from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import useStyles from './styles/InventoryHealthHeader.styles'

type Props = {
  filterOpen: boolean
  onToggleFilter: () => void
  onTriggerPull: () => void
  canTrigger: boolean
  busy: boolean
}

export default function InventoryHealthHeader({
  filterOpen,
  onToggleFilter,
  onTriggerPull,
  canTrigger,
  busy
}: Props) {
  const classes = useStyles()

  return (
    <div className={classes.header}>
      <Typography variant="h3">{getTranslate('Inventory Health')}</Typography>

      <div className={classes.actions}>
        {busy && (
          <CircularProgress
            size={22}
            aria-label={getTranslate('Running diagnostic')}
          />
        )}
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          disabled={!canTrigger || busy}
          onClick={onTriggerPull}>
          {getTranslate('Trigger a fresh pull')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<FilterListIcon />}
          onClick={onToggleFilter}
          aria-expanded={filterOpen}>
          {getTranslate('Filter')}
        </Button>
      </div>
    </div>
  )
}
